import React from "react";
import RatingOverviewContext from "../../ratingOverview/context/ratingOverviewContext";
import RatingOverviewContainer from "../../ratingOverview/ratingOverviewContainer";
import Section from "../../../components/section/section";
import Typography from "@mui/material/Typography";

const WelcomeCoachContainer = (): React.JSX.Element => (
  <Section>
    <Typography
      variant="h6"
      color="initial"
      sx={{
        fontWeight: "bold",
        mb: 2,
      }}
    >
      Deine Bewertungen
    </Typography>

    <RatingOverviewContext>
      <RatingOverviewContainer />
    </RatingOverviewContext>
  </Section>
);

export default WelcomeCoachContainer;
